<template>
  <div :class="$style.additionalCostInfo">
    <span :class="$style.additionalCostText">{{ $t('spotlightAttributes.additionalCost') }}</span>
    <HgTooltip :class="$style.inlineTooltip">
      <div :class="$style.tooltipContent">
        <h3>{{ $t('spotlightAttributes.nettoRentTooltip.title') }}</h3>
        <p>{{ $t('spotlightAttributes.nettoRentTooltip.content') }}</p>
      </div>
    </HgTooltip>
  </div>
</template>

<script lang="ts" setup>
import { HgTooltip } from '@smg-real-estate/domus';

defineOptions({
  name: 'AdditionalCostTooltip',
});
</script>

<style module lang="scss">
.additionalCostInfo {
  display: inline-flex;
  gap: 0.25rem;
  align-items: center;
}

.additionalCostText {
  font-size: 0.875rem;
  color: #666;
}

.inlineTooltip {
  display: inline-flex;
  align-items: center;
}

.tooltipContent {
  h3 {
    margin: 0 0 0.5rem 0;
    font-weight: 600;
  }

  p {
    margin: 0;
  }
}
</style>
